import CommonOperationClass from '../../../commonOperationClass';

const nine = new CommonOperationClass('9');

export default nine;
